import { useEffect, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'

export function intendedBusiness(search: string) {
  const value = new URLSearchParams(search).get('business')
  if (value === null) return { slug: null, invalid: false }
  return /^[a-z0-9][a-z0-9-]{0,78}[a-z0-9]$/.test(value)
    ? { slug: value, invalid: false } : { slug: null, invalid: true }
}

export function rememberSelectedBusiness(slug: string) {
  const url = new URL(window.location.href)
  if (!url.searchParams.has('business')) return
  url.searchParams.set('business', slug)
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`)
}

/** Never render another tenant's calendar underneath a business-specific email CTA. */
export function useBusinessHandoff(currentSlug: string | undefined) {
  const queryClient = useQueryClient()
  const target = intendedBusiness(window.location.search)
  const [failure, setFailure] = useState<unknown>(null)
  const [attempt, setAttempt] = useState(0)
  const required = target.invalid || Boolean(target.slug && currentSlug && target.slug !== currentSlug)
  useEffect(() => {
    if (!target.slug || !currentSlug || target.slug === currentSlug) return
    let disposed = false
    setFailure(null)
    void api('/api/access/select-business', { method: 'POST', body: JSON.stringify({ organizationSlug: target.slug }) })
      .then(() => {
        if (disposed) return
        queryClient.clear()
        window.location.reload()
      }).catch((error: unknown) => { if (!disposed) setFailure(error) })
    return () => { disposed = true }
  }, [attempt, currentSlug, queryClient, target.slug])
  return { target: target.slug, required, failed: target.invalid || Boolean(failure), retry: () => setAttempt((value) => value + 1) }
}
